export default __webpack_public_path__ + "static/media/van-card.329342c8.png";